
class ActiveLinksStyles {
    constructor() {
        // Get the current URL without any query strings
        this.currentUrl = window.location.href.split('?')[0];

        // Get all the links on the page
        this.links = document.getElementsByTagName('a');
        this.events();
    }

    events() {
        // Loop through each link and check if it matches the current URL
        for (var i = 0; i < this.links.length; i++) {
            var linkUrl = this.links[i].href;
            // If linkUrl does not end with a slash, add one
            if (linkUrl[linkUrl.length - 1] !== '/') {
                linkUrl += '/';
            }
            // Compare the current URL to the link URL
            if (this.currentUrl === linkUrl) {
                // Add the 'active' class to the link if it matches the current URL
                this.links[i].classList.add('active');

                // Check if the link is the grandchild of .wp-block-havigation__submenu-container
                if (this.links[i].parentElement.parentElement.classList.contains('wp-block-navigation__submenu-container')) {
                    // Add the 'active' class to the parent link
                    this.links[i].parentElement.parentElement.previousElementSibling.previousElementSibling.classList.add('has-active-child');
                }
            }
        }
    }
}

export default ActiveLinksStyles;








